<nz-space class="mobile-report-control">
  <app-receiptref-select [(ngModel)]="from" class="report-control" (ngModelChange)="fromChange.emit($event)"
    valueField="referenceNo">
  </app-receiptref-select>
  <span class="text-center">
    <span nz-icon nzType="swap-right" nzTheme="outline"></span>
  </span>
  <app-receiptref-select [(ngModel)]="to" class="report-control" (ngModelChange)="toChange.emit($event)"
    valueField="referenceNo"></app-receiptref-select>
</nz-space>
